import {
  Box,
  Text,
  Stack,
  Button,
  useColorModeValue,
  Flex,
} from "@chakra-ui/react";
import Link from "next/link";
import { useRouter } from "next/router";
import Image from "next/image";

export default function SimpleCard({ data, showIcon, industryPage }) {
  const { Description, Icon, name, slug, Title } = data;
  const router = useRouter();
  const portfoliopath = router.pathname === "/portfolio" || industryPage;
  const aboutpath = router.pathname === "/about";

  return (
    <Flex
      id={portfoliopath ? "simpleCard" : ""}
      maxW={{
        base: "full",
        md: aboutpath || portfoliopath ? "full" : "full",
        lg: "350px",
      }}
      w={"full"}
      h={portfoliopath ? { base: "405px", md: "420px" } : "100%"}
      bg={
        portfoliopath
          ? "white"
          : router.pathname == "/technologies"
          ? "white.30"
          : "white"
      }
      boxShadow={
        aboutpath
          ? "unset"
          : "0 3px 25px -5px rgba(0, 0, 0, 0.1),0 10px 10px -5px rgba(0, 0, 0, 0.04)"
      }
      rounded={"2xl"}
      flexDirection={"column"}
      overflow={"hidden"}
      px={aboutpath ? 0 : 5}
      py={aboutpath ? 0 : 7}
      justifyContent={portfoliopath ? "center" : "flex-start"}
    >
      {showIcon && Icon?.data && (
        <Flex
          justify={"center"}
          bg={portfoliopath ? "white" : "unset"}
          rounded={"md"}
          pt={portfoliopath ? 5 : 0}
          pb={router.pathname === "/why-choose-us" ? 0 : 5}
          order={aboutpath ? 1 : 2}
        >
          <Image
            height={65}
            width={portfoliopath ? 140 : 60}
            src={
              process.env.NEXT_PUBLIC_SERVER_URL + Icon?.data?.attributes.url
            }
            alt={Icon?.data?.attributes.name}
            style={{ objectFit: "contain", height: "65px" }}
          />
        </Flex>
      )}
      <Stack
        textAlign={"center"}
        color={useColorModeValue("gray.800", "white")}
        alignItems={"center"}
        borderBottom={
          router.pathname == "/technologies" || portfoliopath
            ? "2px solid #0e2b5c"
            : "unset"
        }
        pb={aboutpath ? 2 : 5}
        order={aboutpath ? 2 : 1}
        justifyContent={"center"}
      >
        <Text
          fontSize={"xl"}
          fontWeight={portfoliopath ? "500" : "normal"}
          color="blue.10"
          textOverflow={"ellipsis"}
        >
          {name || Title}
        </Text>
      </Stack>

      <Box
        h={"100%"}
        borderRadius={"0px 0px 10px 10px"}
        pt={aboutpath || portfoliopath ? 0 : 5}
        order={aboutpath ? 3 : 3}
      >
        <Text
          fontSize={aboutpath || portfoliopath ? "lg" : "md"}
          fontWeight={"normal"}
          color={"lightBlue.10"}
          display={"flex"}
          lineHeight={portfoliopath ? 1.5 : 1.4}
          height={router.pathname == "/technologies" ? "160px" : "auto"}
        >
          {Description}
        </Text>
        {slug && (
          <Link href={"/technologies/" + slug}>
            <Button
              w={"full"}
              margin={"0 auto"}
              bg={"blue.10"}
              color={"white"}
              display={"flex"}
              rounded={"md"}
              _hover={{
                bg: "transparent",
                color: "blue.10",
                border: "1px",
                borderColor: "blue.10",
                borderStyle: "solid",
              }}
              _focus={{
                bg: "blue.10",
              }}
            >
              Check Out
            </Button>
          </Link>
        )}
      </Box>
    </Flex>
  );
}
